import getConfig from 'next/config';
import { HavenRum } from '@havenengineering/module-shared-rum/dist/src/rum';

const {
  publicRuntimeConfig: { datadogConfig },
} = getConfig();

export const startMonitoring = () => HavenRum.Start(datadogConfig);

export default {
  startMonitoring,
};
